import { render } from "./AdminTerminIndex.vue?vue&type=template&id=6ea126f5&scoped=true"
import script from "./AdminTerminIndex.vue?vue&type=script&lang=js"
export * from "./AdminTerminIndex.vue?vue&type=script&lang=js"

import "./AdminTerminIndex.vue?vue&type=style&index=0&id=6ea126f5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea126f5"]])

export default __exports__